// extracted by mini-css-extract-plugin
export var settingsList = "_2y-0";
export var settingsRow = "_2y-1";
export var warningDot = "_2y-2";